import { StandardComp } from "../atoms/standardComp";
import { HorizontalPageLayout, VerticalPageLayout } from "../components/layout";
import { useContext, useEffect, useState } from "react";
import { icon } from "../functions/icons";
import { Alert } from "../components/alert";
import { getAPI } from "../api/api";
import { ReviewFactory } from "../factory/reviewFactory";
import { PageContext } from "../App";
import { ScoreOverview } from "../components/ScoreOverview"

export default function Review({ pageSwap, errorScoreMessage, scoreData, loading, exercises }) {
    return (
            <VerticalPageLayout className={`page-in-animation phone-review phone-review-content ${pageSwap ? "page-out-animation" : ""}`}>
                {errorScoreMessage && (<Alert marginTop={"1rem"} type={"error"} message={errorScoreMessage} />)}
                {!errorScoreMessage && !loading && scoreData.done === true && (<ScoreOverview data={scoreData} title={"Toets resultaat"} />)}
                {scoreData.done === true && exercises.map((exercise, index) => (
                    <div key={index}>
                        <ReviewFactory exercise={exercise}/>     
                    </div>
                ))}
            </VerticalPageLayout>
    );
}



